import { createEnv } from "@t3-oss/env-nextjs";
import { z } from "zod";

export const env = createEnv({
  server: {
    AWS_REGION: z.string().default("eu-west-1"),
    NEXTAUTH_SECRET: z.string(),
    ROOMS_DOMAIN_URL: z.string(),
    DOMAIN_URL: z.string().optional(),
    HUBSPOT_CLIENT_ID: z.string(),
    HUBSPOT_CLIENT_SECRET: z.string(),
    HUBSPOT_INTERNAL_API_KEY: z.string(),
    STRIPE_SECRET_KEY: z.string().optional(),
    HUBSPOT_SCOPE: z
      .string()
      .optional()
      .default(
        [
          "crm.schemas.contacts.read",
          "crm.objects.contacts.read",
          "crm.schemas.contacts.write",
          "crm.objects.contacts.write",

          "crm.schemas.companies.read",
          "crm.objects.companies.read",
          "crm.schemas.companies.write",
          "crm.objects.companies.write",

          "crm.schemas.deals.read",
          "crm.objects.deals.read",
          "crm.schemas.deals.write",
          "crm.objects.deals.write",

          "crm.objects.line_items.read",
          "crm.objects.line_items.write",

          "crm.objects.leads.read",
          "crm.objects.leads.write",

          "crm.schemas.custom.read",
          "crm.objects.custom.read",
          "crm.objects.custom.write",

          "crm.objects.quotes.read",
          "crm.schemas.quotes.read",

          "crm.objects.owners.read",

          "settings.currencies.read",

          "tickets",
          "e-commerce",
          "sales-email-read",
          "files",
        ].join(" ")
      ),
    CROSSBEAM_CLIENT_ID: z.string().optional(),
    CROSSBEAM_CLIENT_SECRET: z.string().optional(),
    SALESFORCE_CLIENT_ID: z.string(),
    SALESFORCE_CLIENT_SECRET: z.string(),
    SLACK_CLIENT_ID: z.string(),
    SLACK_CLIENT_SECRET: z.string(),
    AWS_CONTENT_BUCKET: z.string(),
    POWER_BI_AD_CLIENT_ID: z.string().optional(),
    POWER_BI_AD_CLIENT_SECRET: z.string().optional(),
    INTERNAL_SLACK_BOT_URL: z.string().optional(),
    INTERNAL_SLACK_BOT_UPSELL_URL: z.string().optional(),
    INTERNAL_SLACK_BOT_ALERTS_URL: z.string().optional(),
    CLOUDFLARE_EMAIL: z.email().trim().toLowerCase().optional(),
    CLOUDFLARE_API_KEY: z.string().optional(),
    ENVIRONMENT: z.enum(["test", "development", "staging", "production"]).default("development"),
    TINYBIRD_API_KEY: z.string(),
    IMGPROXY_KEY: z.string().optional(),
    IMGPROXY_SALT: z.string().optional(),
    IMGPROXY_ENDPOINT: z.string().optional(),
  },
  shared: {},
  client: {},
  experimental__runtimeEnv: {},
  skipValidation: !!process.env.SKIP_ENV_VALIDATION || process.env.npm_lifecycle_event === "lint",
});
